import React, { FC } from "react";
import { PersonType } from "../../model/PersonType";
import Home from "./Home";

const ExpertHome: FC = () => <Home viewType={PersonType.Expert} />;

export default ExpertHome;
